<vi-card data-at-dialog id="select-days-dialog" [dialog]="true">
  <div title class="days-header flex flex-row flex-wrap">
    <h3 class="title flex-[100%] max-w-[100%]">
      {{ '+SCHEDULES.COMMON.SELECT_DAYS_TO_SCHEDULE' | translate }}
    </h3>
  </div>
  <vi-text body data-at-body color="light" size="medium">
    <div content class="days-content flex flex-col gap-[22px]">
      <mat-checkbox
        data-at-time-schedule-day-checkbox
        *ngFor="let day of days; let idx = index"
        class="flex-[20px] min-h-[20px] max-h-[20px]"
        [class.checked]="daysSelection[idx].checked"
        id="check-day-{{ idx }}"
        color="primary"
        [(ngModel)]="daysSelection[idx].checked"
        (click)="trackDay()"
        >{{ day }}</mat-checkbox
      >
    </div>
  </vi-text>
  <div footer data-at-footer class="days-footer flex flex-row gap-[10px] justify-end">
    <button
      data-at-cancel
      mat-stroked-button
      color="primary"
      gtm="onCancel"
      gtmAction="Multiple days selection dialog"
      gtmCategory="editSchedule"
      id="cancel-days-selection-btn"
      (click)="onCancel()"
    >
      {{ '+SCHEDULES.BUTTON.CANCEL' | translate }}
    </button>
    <button
      data-at-continue-button
      mat-raised-button
      color="primary"
      gtm="onContinueAfterDaysSelection"
      id="continue-days-selection-btn"
      [disabled]="!canContinue()"
      (click)="onContinue()"
    >
      {{ '+SCHEDULES.BUTTON.CONTINUE' | translate }}
    </button>
  </div>
</vi-card>
